// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup-abr {
  padding: var(--space-4);
  border: 1px solid var(--setup-border);
  border-radius: var(--radius-md);
  background: var(--setup-teal-light);
  color: var(--setup-text);
  font-size: var(--font-size-body-sm);
}

.signup-abr-heading p,
.signup-abr-message {
  margin: var(--space-2) 0 var(--space-3);
  color: var(--setup-secondary);
  line-height: 1.5;
}

.signup-abr-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.signup-abr button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  min-height: var(--control-md);
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--setup-teal);
  border-radius: var(--radius-sm);
  background: var(--surface-primary);
  color: var(--setup-teal);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}

.signup-abr button:hover:not(:disabled) {
  background: var(--setup-teal-pill);
}

.signup-abr button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.signup-abr a {
  color: var(--setup-teal);
  text-decoration: underline;
  font-weight: 500;
}

.signup-abr :is(button, a):focus-visible {
  outline: 2px solid var(--setup-teal);
  outline-offset: 2px;
}

.signup-abr-results {
  display: grid;
  gap: var(--space-3);
  margin: var(--space-4) 0 0;
  padding: 0;
  list-style: none;
}

.signup-abr-results li {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-4);
  border: 1px solid var(--setup-border);
  border-radius: var(--radius-md);
  background: var(--surface-primary);
}

.signup-abr-details {
  display: flex;
  flex: 1 1 180px;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-2);
  min-width: 0;
  overflow-wrap: anywhere;
}

.signup-abr-details > span {
  color: var(--setup-secondary);
  font-size: var(--font-size-body-xs);
}

.signup-abr-status {
  padding: var(--space-1) var(--space-2);
  border-radius: var(--radius-pill);
  background: var(--surface-secondary);
}

.signup-abr-details .signup-abr-status.is-active {
  background: var(--success-soft);
  color: var(--success-text);
}
`, "",{"version":3,"sources":["webpack://./src/components/SignupAbrLookup/style.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,+BAA+B;EAC/B,mCAAmC;EACnC,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;;EAEE,uCAAuC;EACvC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,sCAAsC;EACtC,mCAAmC;EACnC,+BAA+B;EAC/B,kCAAkC;EAClC,wBAAwB;EACxB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B","sourcesContent":[".signup-abr {\n  padding: var(--space-4);\n  border: 1px solid var(--setup-border);\n  border-radius: var(--radius-md);\n  background: var(--setup-teal-light);\n  color: var(--setup-text);\n  font-size: var(--font-size-body-sm);\n}\n\n.signup-abr-heading p,\n.signup-abr-message {\n  margin: var(--space-2) 0 var(--space-3);\n  color: var(--setup-secondary);\n  line-height: 1.5;\n}\n\n.signup-abr-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--space-3);\n}\n\n.signup-abr button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2);\n  min-height: var(--control-md);\n  padding: var(--space-2) var(--space-3);\n  border: 1px solid var(--setup-teal);\n  border-radius: var(--radius-sm);\n  background: var(--surface-primary);\n  color: var(--setup-teal);\n  font: inherit;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.signup-abr button:hover:not(:disabled) {\n  background: var(--setup-teal-pill);\n}\n\n.signup-abr button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.signup-abr a {\n  color: var(--setup-teal);\n  text-decoration: underline;\n  font-weight: 500;\n}\n\n.signup-abr :is(button, a):focus-visible {\n  outline: 2px solid var(--setup-teal);\n  outline-offset: 2px;\n}\n\n.signup-abr-results {\n  display: grid;\n  gap: var(--space-3);\n  margin: var(--space-4) 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n.signup-abr-results li {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-4);\n  padding: var(--space-4);\n  border: 1px solid var(--setup-border);\n  border-radius: var(--radius-md);\n  background: var(--surface-primary);\n}\n\n.signup-abr-details {\n  display: flex;\n  flex: 1 1 180px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--space-2);\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.signup-abr-details > span {\n  color: var(--setup-secondary);\n  font-size: var(--font-size-body-xs);\n}\n\n.signup-abr-status {\n  padding: var(--space-1) var(--space-2);\n  border-radius: var(--radius-pill);\n  background: var(--surface-secondary);\n}\n\n.signup-abr-details .signup-abr-status.is-active {\n  background: var(--success-soft);\n  color: var(--success-text);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
